module.exports = __webpack_public_path__ + "img/Photo-N.073fc816.gif";